export default {
  test: 'grunt', 
  settings: {
    corners: {
      unit: 'px',
      value: 10
    },
    title: 'Empty Popup',
    maxWidth: {
      desktop: {
        unit: 'px',
        value: 450
      }
    },
    height: 'fitContent',
    customHeight: {
      desktop: {
        unit: 'px',
        value: 400
      }
    },
    contentAlignment: 'center',
    position: 'centerCenter',
    showBackdrop: true,
    backdrop: {
      colorLayer: true,
      color: {
        type: 'solid',
        color: '#00000078'
      },
      imageLayer: false,
      image: {
        src: '',
        size: 'contain',
        fixed: 'fixed',
        position: 'Top'
      },
      overlayLayer: false,
      overlay: {
        type: 'solid',
        color: '#00000078'
      },
    },
    background: {
      colorLayer: true,
      color: {
        type: 'solid',
        color: '#ffffff'
      },
      imageLayer: false,
      image: {
        src: '',
        size: 'contain',
        fixed: 'fixed',
        position: 'Top'
      },
      overlayLayer: false,
      overlay: '',
      showIcon: false,
      iconColor: undefined,
    },


  }
}